import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Calendar, PlusCircle } from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { DatePicker } from "antd";
import { useGetAllCustomerQuery, useGetCustomerByIdQuery, useUpdateCustomerMutation } from "../../core/redux/api/userApi";
import dayjs from 'dayjs';
import { useCreateCustomerTransactionMutation, useGetCustomerTransactionQuery } from "../../core/redux/api/OrderApi";
import Table from "../../core/pagination/datatable";

const AddCustomerTransaction = () => {
  const { data: customerResponse } = useGetAllCustomerQuery();
  const [updateCustomer] = useUpdateCustomerMutation();
  const [createCustomerTransaction] = useCreateCustomerTransactionMutation();
 const {data: customerTransactionData }= useGetCustomerTransactionQuery();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [transactionType, setTransactionType] = useState('Credit');
  const [formData, setFormData] = useState({
    date: dayjs(),
    amount: '',
    remarks: ''
  });
  const [customerDetails, setCustomerDetails] = useState({
    customerName: '',
    phone: '',
    currentBalance: '',
    address: ''
  });

  const { data: singleCustomer } = useGetCustomerByIdQuery(selectedCustomer?.value, {
    skip: !selectedCustomer?.value
  });

  const customersList = customerResponse?.map(item => ({
    value: item?._id,
    label: item?.customerName
  }));

  useEffect(() => {
    if (singleCustomer?.data) {
      setCustomerDetails({
        customerName: singleCustomer.data.customerName,
        phone: singleCustomer.data.phone,
        currentBalance: singleCustomer.data.currentBalance,
        address: singleCustomer.data.address
      });
    }
  }, [singleCustomer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setFormData(prev => ({
      ...prev,
      date
    }));
  };

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedCustomer || !formData.amount) {
      alert('Please select a customer and enter amount');
      return;
    }
  
    try {
      const amount = parseFloat(formData.amount);
      const currentCredit = parseFloat(customerDetails.currentBalance);
      
      let updatedCredit;
      if (transactionType === 'Credit') {
        updatedCredit = currentCredit + amount;
      } else {
        updatedCredit = currentCredit - amount;
      }
  
      // Update customer credit limit
      await updateCustomer({
        id: selectedCustomer.value,
        currentBalance: updatedCredit,
      });
      const customerTransactoData = {
        customerId: selectedCustomer.value,
        amount: amount,
        type: transactionType,
        remarks: formData.remarks || '',
        previousCredit: currentCredit,
        updatedCredit: updatedCredit
      }
      // Create transaction history record
      await createCustomerTransaction(customerTransactoData);
      
      // Reset form
      setFormData({
        date: dayjs(),
        amount: '',
        remarks: ''
      });
      setSelectedCustomer(null);
      
      // Close modal or show success message
      document.getElementById('add-customer-transaction')?.classList.remove('show');
      document.querySelector('.modal-backdrop')?.remove();
      
      // Optionally refresh transaction history or customer data
      // fetchCustomerDetails(selectedCustomer.value);
      // fetchTransactionHistory(selectedCustomer.value);
      alert("Amount Sumbitted successfully");
      setCustomerDetails({
        customerName: '',
        phone: '',
        currentBalance: '',
        address: ''
      });
    } catch (error) {
      console.error('Error updating customer:', error);
      alert('Failed to update customer');
    }
  };

  const customerTransactionColumns = [
    {
      title: "Transaction ID",
      dataIndex: "_id",
      render: (id) => <span>{id || "-"}</span>,
    },
    {
      title: "Customer Name",
      dataIndex: ["customerId", "customerName"], // Access nested customerName
      render: (customerName, record) => (
        <span>
          {customerName || record.customerId?.customerName || "-"}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (amount, record) => (
        <span style={{ color: record.type === 'Credit' ? 'green' : 'red' }}>
          {amount.toFixed(2)}
        </span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) => (
        <span style={{ color: type === 'Credit' ? 'green' : 'red' }}>
          {type}
        </span>
      ),
      filters: [
        { text: 'Credit', value: 'Credit' },
        { text: 'Debit', value: 'Debit' },
      ],
      onFilter: (value, record) => record.type === value,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (date) => (
        <span>{new Date(date).toLocaleDateString()}, {new Date(date).toLocaleTimeString()}</span>
      ),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (remarks) => remarks || "-",
    }
  ];

  return (
    <div className="modal fade" id="add-customer-transaction">
      <div className="modal-dialog add-centered">
        <div className="modal-content">
          <div className="page-wrapper p-0 m-0">
            <div className="content p-0">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Customer Ledger</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Customer Name</label>
                          <div className="row">
                            <div className="col-lg-10 col-sm-10 col-10">
                              <Select
                                classNamePrefix="react-select"
                                options={customersList}
                                value={selectedCustomer}
                                onChange={handleCustomerChange}
                                placeholder="Select Customer"
                              />
                            </div>
                            <div className="col-lg-2 col-sm-2 col-2 ps-0">
                              <div className="add-icon">
                                <Link to="#" className="choose-add"> 
                                  <PlusCircle className="plus" /> 
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Date</label>
                          <div className="input-groupicon calender-input">
                            <Calendar className="info-img" />
                            <DatePicker
                              value={formData.date}
                              onChange={handleDateChange}
                              className="filterdatepicker"
                              format="DD-MM-YYYY"
                              placeholder="Choose Date"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount here"
                            name="amount"
                            value={formData.amount}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Remarks</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Remarks if any"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-3 mt-4">
                        <div className="btn-group-horizontal" role="group" aria-label="Transaction type">
                          <input
                            type="radio"
                            className="btn-check"
                            name="transactionType"
                            id="credit"
                            value="Credit"
                            checked={transactionType === 'Credit'}
                            onChange={() => setTransactionType('Credit')}
                          />
                          <label className="btn btn-outline-success me-2" htmlFor="credit">Credit</label>
              
                          <input
                            type="radio"
                            className="btn-check"
                            name="transactionType"
                            id="debit"
                            value="Debit"
                            checked={transactionType === 'Debit'}
                            onChange={() => setTransactionType('Debit')}
                          />
                          <label className="btn btn-outline-danger me-2" htmlFor="debit">Debit</label>
              
                          <span className="mt-2">Selected: <strong>{transactionType}</strong></span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Customer Name</label>
                          <input
                            type="text"
                            placeholder="Customer Name"
                            readOnly={true}
                            className="form-control"
                            value={customerDetails.customerName}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>Mobile</label>
                          <input
                            type="text"
                            placeholder="Mobile"
                            readOnly={true}
                            className="form-control"
                            value={customerDetails.phone}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label>{customerDetails.currentBalance >= 0 ? "Crdit" : "Debit"} Amount</label>
                          <input
                            type="text"
                            readOnly={true}
                            placeholder="credit"
                            className="form-control"
                            value={customerDetails.currentBalance}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks mb-5">
                          <label>Address</label>
                          <input
                            type="text"
                            placeholder="Address"
                            readOnly={true}
                            className="form-control"
                            value={customerDetails.address}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 text-end">
                        <button
                          type="button"
                          className="btn btn-cancel add-cancel me-3"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-submit add-sale" data-bs-dismiss="modal">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="table-responsive">
  <Table 
    columns={customerTransactionColumns} 
    dataSource={customerTransactionData} 
    rowKey="_id"
  />
</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerTransaction;